var _path, _path2, _use, _g, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 800,
    width: 1200,
    fill: "#049fd9",
    viewBox: "-32.4 -28.46125 280.8 170.7675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.48 76.164c-.282-.077-4.621-1.196-9.232-1.196-8.73 0-13.986 4.714-13.986 11.734 0 6.214 4.397 9.313 9.674 10.98.585.193 1.447.463 2.021.653 2.349.739 4.224 1.837 4.224 3.739 0 2.127-2.167 3.504-6.878 3.504-4.14 0-8.109-1.184-8.945-1.395v8.637c.466.099 5.183 1.025 10.222 1.025 7.248 0 15.539-3.167 15.539-12.595 0-4.573-2.8-8.783-8.947-10.737l-2.613-.832c-1.559-.492-4.342-1.289-4.342-3.574 0-1.805 2.062-3.076 5.859-3.076 3.276 0 7.263 1.101 7.404 1.145zm80.041 18.243c0 5.461-4.183 9.879-9.796 9.879-5.619 0-9.791-4.418-9.791-9.879 0-5.45 4.172-9.87 9.791-9.87 5.613 0 9.796 4.42 9.796 9.87m-9.796-19.427c-11.544 0-19.823 8.707-19.823 19.427 0 10.737 8.279 19.438 19.823 19.438 11.543 0 19.834-8.701 19.834-19.438 0-10.72-8.291-19.427-19.834-19.427M70.561 113.177h-9.472V75.645h9.472"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M48.07 76.325c-.89-.264-4.18-1.345-8.636-1.345-11.526 0-19.987 8.218-19.987 19.427 0 12.093 9.34 19.438 19.987 19.438 4.23 0 7.459-1.002 8.636-1.336v-10.075c-.407.226-3.503 1.992-7.957 1.992-6.31 0-10.38-4.441-10.38-10.019 0-5.748 4.246-10.011 10.38-10.011 4.53 0 7.576 1.805 7.957 2.004"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    transform: "translate(98.86)",
    xlinkHref: "#a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.074)",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M61.061 4.759c0-2.587-2.113-4.685-4.703-4.685-2.589 0-4.702 2.098-4.702 4.685v49.84a4.701 4.701 0 004.702 4.699 4.701 4.701 0 004.703-4.699zM35.232 22.451c0-2.586-2.112-4.687-4.702-4.687s-4.702 2.101-4.702 4.687v22.785a4.701 4.701 0 004.702 4.699 4.701 4.701 0 004.702-4.699zM9.404 35.383c0-2.587-2.112-4.684-4.702-4.684C2.115 30.699 0 32.796 0 35.383v9.853a4.703 4.703 0 009.404 0"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    transform: "matrix(-1 0 0 1 112.717 0)",
    xlinkHref: "#b"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    transform: "matrix(-1 0 0 1 216 0)",
    xlinkHref: "#c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand5);
export default __webpack_public_path__ + "static/media/brand5.f056a09c63aa671f89f6bc4a52a87c03.svg";
export { ForwardRef as ReactComponent };